export default __webpack_public_path__ + "static/media/desjardins.c974419a.png";